module.exports = __webpack_public_path__ + "media/images/plans/wedding_compact/hall-list/plan-wedding-lineup-tokai-4-e30103aa5906b25ed8ccf886feb917b4.png";